var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86195 5.5286C3.1223 5.26825 3.54441 5.26825 3.80476 5.5286L8.00002 9.72386L12.1953 5.5286C12.4556 5.26825 12.8777 5.26825 13.1381 5.5286C13.3984 5.78895 13.3984 6.21106 13.1381 6.47141L8.47142 11.1381C8.3464 11.2631 8.17683 11.3333 8.00002 11.3333C7.82321 11.3333 7.65364 11.2631 7.52862 11.1381L2.86195 6.47141C2.6016 6.21106 2.6016 5.78895 2.86195 5.5286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0499715fdd7c8d2862afc82a58e95c17.svg";
export { ForwardRef as ReactComponent };